import { IUpdateProjetosChecklistUseCase } from "../../../presentation/useCases/update/update_projetos_checklist_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * UpdateProjetosChecklistUseCase
 */

export class UpdateProjetosChecklistUseCase implements IUpdateProjetosChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateProjetosChecklist(id: number, statusCheckList: boolean, nome: string, descricao?: string): Promise<void> {
    await this.repository.updateProjetosChecklist(id,statusCheckList, nome, descricao);
  }
}
